import React, { useEffect } from 'react'
import { Grid, Typography, withStyles } from '@material-ui/core'
import colors from '../../../../assets/colors'

import styles from '../../../../resources/theme/global'
import Filter from './Filter'
import List from './List'
import { useDispatch, useSelector } from 'react-redux'
import { usePermissions } from '../../../../hooks/usePermission'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useQueryParams } from '../../../../util/utils'
import { fetchServiceItems } from '../ItemsReportActions'

const ItemsReport = props => {
  const { classes } = props

  const dispatch = useDispatch()
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canRead } = usePermissions()
  const location = useLocation()
  const filters = useQueryParams(location.search)

  useEffect(() => {
    dispatch(fetchServiceItems(filters))
  }, [location])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography
              variant="h4"
              style={{ fontSize: '20px' }}
              color={colors.primary}
            >
              Relátorio de Itens
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Filter />
      </Grid>

      <Grid item xs={12}>
        {canRead('modulo-parceiros-relatorio-itens', permissionUser) && (
          <List classes={classes} />
        )}
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(ItemsReport)
